import { _ as _toConsumableArray } from '../unsorted/toConsumableArray.js';
import { convertVariantToValidCssClass } from './slugHelpers.js';

function getCurrentSizeClass(size, startingSize, safeSizes, breakpointAsArray, windowWidth) {
  if (!windowWidth) {
    return startingSize;
  }
  if (Array.isArray(size)) {
    var actualResponsiveSizes = _toConsumableArray(size);
    actualResponsiveSizes.shift();
    return actualResponsiveSizes.reduce(function (accum, curr, index) {
      var newAccum = accum;
      if (curr !== null && windowWidth >= breakpointAsArray[index]) {
        newAccum = curr;
      }
      return newAccum;
    }, startingSize);
  }

  // @TODO: work out how to type the below function, so that it keeps the types of the input
  // but simply swaps "/" for "_". This should be possible with some ts magic:
  // https://www.totaltypescript.com/writing-string-replace-in-typescript
  return convertVariantToValidCssClass(safeSizes.indexOf(size) !== -1 ? size : startingSize);
}

export { getCurrentSizeClass };
//# sourceMappingURL=responsiveHelpers.js.map
